import React from "react";

const ReviewCards = () => (
  <div className="elfsight-app-dd480662-4b6c-47a6-b22d-d2efb71cdd79" />
);

export default ReviewCards;
